// extracted by mini-css-extract-plugin
export default {"newMarketLink":"NewMarketWidget_newMarketLink__fkfQg"};